import Chip from '@mui/material/Chip'

import { useMe } from '@shared/providers/src/MeProvider'
import { BuildEnv, toTitleCase, userRoleToLabel } from '@shared/utils'

const envToLabel = {
  [BuildEnv.Staging]: 'Staging',
  [BuildEnv.QA]: 'QA',
  [BuildEnv.Local]: 'Local',
}

export default function Environment() {
  const env = import.meta.env.VITE_BUILD_ENV
  const me = useMe()

  if (env === BuildEnv.Production) return null

  return <Chip variant="contained" color="primary" label={`${envToLabel[env] || env} - ${toTitleCase(userRoleToLabel[me.role])}`} />
}
